import stretchToolSettings from './stretch-tool-settings';

export default {
  stretchToolSettings,
};
